/**
 * @generated SignedSource<<e986fe92e47f19abc1fcf6d123b5ad6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CollectionMedia_collection$data = {
  readonly logo: string | null | undefined;
  readonly " $fragmentType": "CollectionMedia_collection";
};
export type CollectionMedia_collection$key = {
  readonly " $data"?: CollectionMedia_collection$data;
  readonly " $fragmentSpreads": FragmentRefs<"CollectionMedia_collection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CollectionMedia_collection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": null
    }
  ],
  "type": "CollectionType",
  "abstractKey": null
};

(node as any).hash = "10f873d6fd67984f48bf64056739b639";

export default node;
